(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ENV', 'Context', 'User', 'MaintenanceSettingsService', '$cookies', '$filter', '$rootScope'];

    function NavbarController($state, Auth, Principal, ENV, Context, User, MaintenanceSettingsService, $cookies, $filter, $rootScope) {
        var vm = this;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.restoreUser = restoreUser;
        vm.closeMaintenanceMessage = closeMaintenanceMessage;
        vm.togglePopup = togglePopup;
        vm.$state = $state;
        vm.domainName = '';
        vm.domainId = 0;
        vm.maintenance = {};
        vm.isMaintenance = false;
        vm.popupToggled = false;
        getDomainName();
        vm.licence = $rootScope.licence;

        vm.maintUserCheck = angular.isDefined($cookies.get("maintenance"));

        MaintenanceSettingsService.getMaintenanceDetailSetting().$promise.then(function (data) {
            vm.maintenance = data;
            vm.isMaintenance = new Date(data.releaseDate).getTime() > new Date().getTime();
        });

        Context.query().$promise.then(
            function (resp) {
                vm.domains = resp;
            });

        function getDomainName() {
            Principal.identity().then(function (data) {
                vm.username = data.login;
                vm.impersonated = data.impersonatedUser;
                vm.domainName = data.context.domainName;
                if(data.context.licenseExpirationDate != null) {
                    var today = new Date();
                    var expiration = new Date(data.context.licenseExpirationDate);
                    var distance = parseInt((expiration - today) / (1000 * 60 * 60 * 24)) + 1;
                    if (distance < 30) {
                        vm.expirationDate = data.context.licenseExpirationDate;
                        if (distance > 1) {
                            vm.expireDays = 'in ' + distance + " days";
                        } else {
                            vm.expireDays = 'tomorrow';
                        }
                    }
                }
                vm.domainId = data.context.id;
            }, function () {
                vm.domainName = 'N/D';
            });
        }

        function login() {
            $state.go('login');
        }

        Principal.identity().then(function (account) {
            vm.domainContext = account.context.domainName;
        });

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function restoreUser() {
            User.restore();
            $state.go("context", null, {reload: true});
        }

        function closeMaintenanceMessage() {
            vm.maintUserCheck = true;
            $cookies.put("maintenance", "close", {expires: vm.maintenance.releaseDate});
            if (vm.popupToggled){
                togglePopup();
            }
        }

        function togglePopup() {
            vm.popupToggled = !vm.popupToggled;
        }
    }
})();
